import { translateBackend } from '@assets/i18n/config';
import { Icon } from '@mui/material';
import { useTabNavTokens } from '@ovComponents/3-pattern/tabNav/tabNav.tokens';
import { WorkflowCompletionForm } from '@ovComponents/4-module/workflowCompletion/components/workflowCompletionForm';
import { InlineImage } from '@pages/client/components/documents/inlineImage';
import { InlineImageLocal } from '@pages/client/components/documents/inlineImageLocal';
import { AnalyticsContext } from '@providers/analyticsProvider';
import { ovAnalyticsEvents } from '@utils/analytics/analytics';
import { Box, Grid, Typography, useTheme } from 'hephaestus/web';
import { kebabCase } from 'lodash-es';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const ReviewVisual = ({
  options,
  loading,
  continueFunc,
}: {
  options: any;
  loading: boolean;
  continueFunc: any;
}) => {
  const { t } = useTranslation(['workflowCompletions']);
  const theme = useTheme();
  const tokens = useTabNavTokens(theme);
  const { sendAnalytic } = useContext(AnalyticsContext);
  const submit = async () => {
    sendAnalytic(ovAnalyticsEvents.workflowsReviewContinueButtonSelect);
    await continueFunc();
  };

  const styles: any = {
    objectFit: 'cover',
    minHeight: '60px',
    width: '80px',
    borderRadius: '15px',
  };

  return (
    <WorkflowCompletionForm
      onSubmit={submit}
      submitButtonProps={{
        dataTestId: `review-${kebabCase(options?.title?.en)}-continue-button`,
        label: t('workflowCompletions:continue'),
        disabled: loading,
      }}
    >
      <Typography variant='displayLarge' sx={{ mt: 1 }}>
        {translateBackend(options?.title)}
      </Typography>
      <Typography variant='bodyLarge' sx={{ mb: 5 }}>
        <ReactMarkdown linkTarget='_blank' remarkPlugins={[remarkGfm]}>
          {translateBackend(options?.subtitle)}
        </ReactMarkdown>
      </Typography>
      {options?.options?.map((option: any) => (
        <Box
          sx={{
            display: 'flex',
            mb: 5,
            opacity: option.state === 'DISABLED' ? 0.4 : 1,
          }}
        >
          {option?.value?.file && (
            <Box
              sx={{
                mr: 2,
              }}
            >
              <InlineImageLocal file={option?.value?.file} style={styles} />
            </Box>
          )}
          {option?.value?.value && (
            <Box
              sx={{
                mr: 2,
              }}
            >
              <InlineImage
                fileDocumentId={option?.value?.value}
                style={styles}
              />
            </Box>
          )}
          <Grid container size={12}>
            <Grid size={option?.icon ? 11 : 12}>
              <Box>
                <Typography variant='headingSmall' sx={{ mb: 0.5 }}>
                  {translateBackend(option.title)}
                </Typography>
                <Typography variant='bodyLarge'>
                  {translateBackend(option.subtitle)}
                </Typography>
              </Box>
            </Grid>
            {option?.icon ? (
              <Grid
                size={option.trailing ? 1 : 0}
                sx={{
                  ml: 'auto',
                }}
              >
                <Icon sx={{ fontSize: '30px', color: tokens.text.active }}>
                  {option.icon}
                </Icon>
              </Grid>
            ) : null}
          </Grid>
        </Box>
      ))}
    </WorkflowCompletionForm>
  );
};

export default ReviewVisual;
